import dompurify from 'dompurify';
import { motion } from 'motion/react';
const sanitizer = dompurify.sanitize;

function RecognitionAnnouncements({ currentUser }) {
	const recognitionAnnouncementText =
		currentUser?.company?.recognitionSettings?.recognitionAnnouncementText ||
		'';

	return recognitionAnnouncementText?.length > 0 ? (
		<div className="home">
			<div style={{ marginBottom: 12 }} className="d-card">
				<div className="d-card-head">
					<h4 className="dashboard-title">Recognition Announcements</h4>
				</div>
				<motion.div
					className="recognition-announcement"
					style={{ color: 'rgba(0, 0, 0, 0.65)' }}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 0.5, ease: 'easeOut' }}
				>
					<div
						dangerouslySetInnerHTML={{
							__html: sanitizer(recognitionAnnouncementText, {
								ADD_ATTR: ['target', 'rel'],
							}),
						}}
					/>
				</motion.div>
			</div>
		</div>
	) : null;
}

export default RecognitionAnnouncements;
